<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 sticky top-0 uppercase bg-gray-50 z-20">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50 z-10"
      >
        <!-- id -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{
              'RCD-' + row["id"]
            }}
          </div>
        </td>

        <!-- setor responsável -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <div class="px-1 uppercase">
            <div class="text-base font-semibold">
              {{ row["relatoCompe"] }}
            </div>
          </div>
        </th>

        <!-- classificação -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="font-normal text-gray-500 uppercase">
            {{
              row["relatoClassi"]
            }}
          </div>
        </td>

        <!-- status -->
        <td class="px-6 py-4 uppercase">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
              :class="[
                row['status'] === 'crítico' || row['status'] === null ? 'bg-red-500' : '',
                row['status'] === 'controlado' ? 'bg-yellow-500' : '',
                row['status'] === 'resolvido' ? 'bg-green-500' : '',
                row['status'] === 'cancelado' ? 'bg-gray-500' : '',
              ]"
            ></div>
            {{ row["status"] ?? 'crítico' }}
          </div>
        </td>

        <!-- empresa relatada -->
        <td class="px-1 md:px-6 py-4 ml-auto mr-auto uppercase">
          {{
            row["relatoEmpresa"]
          }}
        </td>

        <!-- ações -->
        <td class="py-4 sticky -right-1 bg-white">
          <div class="flex justify-center font-medium">

            <!-- Tomar ação -->
            <a
              title="Detalhes do relato"
              class="text-green-600 mr-1 cursor-pointer"
              @click="openModal(data[index])"
            >
              <component :is="PhFileText" class="h-7 w-7 md:h-6 md:w-6" />
            </a>

            <!-- Remover documento -->
            <a
              title="Desativar relato"
              class="text-red-600 ml-1 cursor-pointer"
              @click="deleteDoc(row['id'])"
            >
              <component :is="PhTrash" class="h-7 w-7 md:h-6 md:w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { PhFileText, PhTrash } from '@phosphor-icons/vue'
import { defineProps } from 'vue'
import { dataRcd } from '../../store'

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

function deleteDoc (doc, id) {
  emit('delete', doc, id)
}

function openModal (data) {
  dataRcd.dispatch('setModalActive', data)
}

</script>
